var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notification.message)?_c('div',{class:`notification message ${_vm.notification.type}`},[_c('p',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.notification.message)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }